import {ViewPopup} from './ViewPopup.ts'

export class ViewPopupServerUpdate extends ViewPopup {
    constructor() {
        super({key: 'strings:popups.patchNote.announcement'}, {key: 'strings:popups.errors.serverUpdate'}, () => undefined, () => undefined, false)
        this.removeCheckButton()
        this.removeXButton()
        this.preventClicksOutsideOfPopupFromClosingPopup = true
    }
}
